import React, { useState, useEffect } from "react";
import { HeaderComponent, BodyComponent, InputText, SaveButton, UploadFile } from '@comps/components';
import { MEDIA_FORMATS } from "@utils/mediaFormats";
import { Form, Row, Col } from "antd";
import toast from "@comps/toast";
import { getErrorProps, makeRequest } from "@utils/helpers";
import { updateProfiles } from "./requests";
import { useSelector } from 'react-redux';

const pageConfig = {
  headers: {
    title: "Profile",
    breadcrumb: [
      {
        name: "Profile",
        path: "/"
      }
    ]
  }
}

const formName = "profile_form";

const Profile = () => {
  const [loader, setLoader] = useState(false);
  const [initialData, setInitialData] = useState({});
  const [errors, setErrors] = useState([]);
  const authUser = useSelector((state) => state.auth.authUser);
  const [image, setImage] = useState(null);


  useEffect(() => {
    getProfilesData();
  }, [])

  const getProfilesData = () => {
    setInitialData(authUser);
  }

  const onError = (error) => {
    toast.error("Something went wrong");
  }

  const onFinish = (values) => {
    let payload = {
      ...values,
      id: initialData.id,
      file: image
    }
    makeRequest(setLoader, updateProfiles, payload, onUpdateSuccess, onError);
  }

  const onUpdateSuccess = (res) => {
    toast.success("Profiles updated successfully");
    setInitialData(res);
    localStorage.setItem('user', JSON.stringify(res));
  }

  return (
    <>
      <HeaderComponent headers={ pageConfig.headers }>
      </HeaderComponent>
      <BodyComponent narrow>
        <h3>Update Profile</h3>
        { initialData && initialData.name &&
          <Form
            layout="vertical"
            name={ formName }
            onFinish={ onFinish }
            initialValues={ initialData }
          >
            <div style={ { padding: 30 } }>
              <Row gutter={ 30 }>
                <Col span={ 24 }>
                  <Form.Item onChange={
                    () => setErrors([])
                  } name="name" rules={ rules.name } label="Full Name :" className="da-mb-16"
                    { ...getErrorProps(errors['name']) }
                  >
                    <InputText placeholder="Enter your name" />
                  </Form.Item>
                  <Form.Item onChange={
                    () => setErrors([])
                  } name="email" rules={ rules.email } label="Email :" className="da-mb-16"
                    { ...getErrorProps(errors['email']) }
                  >
                    <InputText disabled={ true } placeholder="Enter your email" />
                  </Form.Item>
                  <Row className="mb-3">
                    <Col span={ 24 }>
                      <p className="m-0 p-0">Profile Image :</p>
                      <UploadFile
                        accept={ MEDIA_FORMATS.image.accept }
                        extensions={ MEDIA_FORMATS.image.extensions }
                        formatLabel={ MEDIA_FORMATS.image.label }
                        onUpload={ setImage } />
                    </Col>
                  </Row>
                </Col>
                <Col span={ 24 } className="text-right ">
                  <SaveButton style={ { width: '100%' } } form={ formName } key="create_button" htmlType="submit" state={ loader } />
                </Col>
              </Row>
            </div>
          </Form>
        }

      </BodyComponent>
    </>
  )

}

const rules = {
  name: [
    { required: true, message: 'Please input your name!', },
    { min: 3, message: 'Minimum name length is 3', },
    { max: 100, message: 'Maximum name length is 100', },
  ]
};

export default Profile